import '@babel/polyfill'
import Vue from 'vue'
// eslint-disable-next-line no-unused-vars
import _lib from '@/utils/commonLib'
import './cube-ui'
import 'swiper/dist/css/swiper.min.css'
import '@/styles/index.css'
import '@/styles/iconfont.scss'
import '@/utils/init_rem'
import App from '@/App.vue'
import store from '@/store'
import baseMixin from '@/mixin/baseMixin'
import router from '@/routes'
// import './utils/errReport'
import '@lib/utils/eventBus'
// eslint-disable-next-line no-unused-vars
import _dateHelper from '@lib/utils/dateHelper.js'
import { autoInitSdkByPlatform } from '@tujia/fe-lib-bridge/lib'
import { platformEnv } from '@/utils/platformConfig.js'
import '@tujia/tj-mob-ui/lib/index.css'
import '@/utils/fas.js'
import '@/utils/watcher.js'
import * as uiLib from '@tujia/tj-mob-ui'
// 延迟加载插件
import VueLazyload from 'vue-lazyload'

Vue.use(uiLib)
Vue.use(VueLazyload, {
  lazyComponent: true,
  preLoad: 1.8
})
Vue.prototype.platformEnv = platformEnv
// 注入小程序sdk
autoInitSdkByPlatform()

// for test
if (window.location.href.indexOf('vconsole=true') > -1) {
  import(`vconsole/dist/vconsole.min.js`).then((vc) => {
    // eslint-disable-next-line
    var vConsole = new vc.default()
  })
}

Vue.config.productionTip = false
Vue.mixin(baseMixin)

if (process.env.VUE_APP_LOCAL === 'Q') {
  const hysdk = window.hysdk
  hysdk &&
    hysdk.config({
      debug: false,
      wechatSupport: true
    })
  hysdk.ready(() => {
    hysdk.register('openHybridCashier', 'hbCashier', 'qmp')
  })
  // 去哪儿hybird插件 在使用hysdk前必须config
  const timer = window.setInterval(() => {
    if (hysdk) {
      hysdk.showAllNonBaseMenuItem({})
      window.clearInterval(timer)
    }
  }, 800)
}
// 根据平台不同进行针对性打包
if (process.env.VUE_APP_LOCAL !== 'Q' && process.env.VUE_APP_LOCAL !== 'C') {
  if (!window.nostorage) {
    require('@lib/business/tjBridge/WebViewJavascriptBridge.js')
    window.tjGlobal.host = {
      TUJIA_DOMAIN: process.env.VUE_APP_TUJIA_DOMAIN
    }
  }
}

const app = new Vue({
  router,
  store,
  render: (h) => h(App)
})

router.onReady(async() => {
  await store.dispatch('init')
  app.$mount('#app')
})
